import {
  ACTUAL_IMPLEMENTATION_LABEL,
  ANALYTICS,
  DETAILS_OF_EXPENSES_LABEL,
  DIRECTION_INDICATORS_LABEL,
  EXPENSE_BY_ARTICLES_REPORT_LABEL,
  FINANCIAL_RESULTS_REPORT_LABEL,
  ORGANIZATION_CLIENTS_GROWTH_LABEL,
  REVENUE_STATEMENT_LABEL,
  SALARY_REPORT_LABEL,
  SALARY_REPORT,
  ACTUAL_IMPLEMENTATION,
  DIRECTION_INDICATORS,
  ORGANIZATION_CLIENTS_GROWTH,
  REVENUE_STATEMENT,
  FINANCIAL_RESULTS_REPORT,
  EXPENSE_BY_ARTICLES_REPORT,
  DETAILS_OF_EXPENSES,
  BRANCH_INDICATORS_REPORT,
  BRANCH_INDICATORS_REPORT_LABEL,
} from '@app/constants';
import type { GetTabsDataProps } from '@app/pages/Analytics/AnalyticsLayout/types';

import {
  DirectionIndicators,
  OrganizationClientsGrowth,
  RevenueStatement,
  ActualImplementation,
  DetailsOfExpensesReport,
  ExpenseByArticlesReport,
  SalaryReport,
  BranchIndicatorsReport,
} from '@pages/Analytics';
import { AnalyticsService } from '@pages/Analytics/AnalyticsService/AnalyticsService.main';
import { FinancialResultsReport } from '@pages/Analytics/FinancialResultsReport/ui/FinancialResultsReport.main';

import type { TabsProps } from 'antd';

export const getTabsData = ({
  hasUserRightToIncomesReport,
  hasUserRightToFactImplReport,
  hasUserRightToExpenseByArticlesReport,
  hasUserRightToPnlReport,
  hasUserRightToDetailsOfExpensesReport,
  hasUserRightToFinancialBranchIndicatorReport,
  hasUserRightToSalary,
}: GetTabsDataProps) => {
  const extra: TabsProps['items'] = hasUserRightToSalary
    ? [
        {
          key: SALARY_REPORT,
          label: SALARY_REPORT_LABEL,
          children: <SalaryReport />,
        },
      ]
    : [];

  const analyticsTabs: TabsProps['items'] = [
    {
      key: ANALYTICS,
      label: 'Главная',
      children: <AnalyticsService />,
    },
    {
      key: DIRECTION_INDICATORS,
      label: DIRECTION_INDICATORS_LABEL,
      children: <DirectionIndicators />,
    },
    {
      key: ORGANIZATION_CLIENTS_GROWTH,
      label: ORGANIZATION_CLIENTS_GROWTH_LABEL,
      children: <OrganizationClientsGrowth />,
    },
    ...(hasUserRightToPnlReport
      ? [
          {
            key: FINANCIAL_RESULTS_REPORT,
            label: FINANCIAL_RESULTS_REPORT_LABEL,
            children: <FinancialResultsReport />,
          },
        ]
      : []),
    ...(hasUserRightToIncomesReport
      ? [
          {
            key: REVENUE_STATEMENT,
            label: REVENUE_STATEMENT_LABEL,
            children: <RevenueStatement />,
          },
        ]
      : []),
    ...(hasUserRightToFactImplReport
      ? [
          {
            key: ACTUAL_IMPLEMENTATION,
            label: ACTUAL_IMPLEMENTATION_LABEL,
            children: <ActualImplementation />,
          },
        ]
      : []),
    ...(hasUserRightToDetailsOfExpensesReport
      ? [
          {
            key: DETAILS_OF_EXPENSES,
            label: DETAILS_OF_EXPENSES_LABEL,
            children: <DetailsOfExpensesReport />,
          },
        ]
      : []),
    ...(hasUserRightToExpenseByArticlesReport
      ? [
          {
            key: EXPENSE_BY_ARTICLES_REPORT,
            label: EXPENSE_BY_ARTICLES_REPORT_LABEL,
            children: <ExpenseByArticlesReport />,
          },
        ]
      : []),
    ...(hasUserRightToFinancialBranchIndicatorReport
      ? [
          {
            key: BRANCH_INDICATORS_REPORT,
            label: BRANCH_INDICATORS_REPORT_LABEL,
            children: <BranchIndicatorsReport />,
          },
        ]
      : []),
    ...extra,
  ];

  return analyticsTabs;
};
